<template>
    <div>
        <a
            class="btn btn-md is-ghost float-right cursor-pointer hidden xl:flex"
            @click="$modal.show('import-addresses-for-sales-project-transfer')"
        >
            Hämta adresser
        </a>
        <a
            class="list-item hidden xl:hidden"
            @click="$modal.show('import-addresses-for-sales-project-transfer')"
        >
            Hämta adresser
        </a>
        <adaptive-form-modal
            name="import-addresses-for-sales-project-transfer"
            primary-button-text="Starta import"
            primary-button-class="is-primary"
            title="Hämta adresser från annat säljprojekt"
            :redirect-to="redirectRoute"
            :action="actionRoute"
        >
            <div>
                <div class="mb-xl p-xl bg-neutral-lightest text-sm">
                    <p>Observera att filen behöver ha formatet .xslx och innehålla LID.</p>
                </div>

                <input
                    id="file"
                    type="file"
                    name="file"
                    class="hidden"
                    @change="fileSelected"
                >
                <label class="btn is-primary cursor-pointer" for="file">
                    Välj fil
                </label>

                <span class="ml-md text-sm">
                    <span v-if="file">
                        Fil har valts
                    </span>
                    <span v-else>
                        Ingen fil har valts
                    </span>
                </span>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            salesProject: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                file: null,
            };
        },

        computed: {
            actionRoute() {
                const params = [
                    this.salesProject,
                ];

                return route('api.sales-projects.move-selected-addresses.move', params);
            },
            redirectRoute() {
                return route('admin.sales-projects.addresses.index', [this.salesProject]);
            },
        },

        methods: {
            fileSelected(e) {
                this.file = e.target.value;
            },
        },
    };
</script>
